export const HOME_ROUTE = "/";
export const UPLOAD_FILE_ROUTE = "/upload-files-old";
// export const CONTACT_US_ROUTE = "/contact-us";
export const LOGIN_ROUTE = "/login";
export const SIGNUP_ROUTE = "/signup";
export const DOWNLOAD_ROUTE = "/download";
export const SUPER_USER_ROUTE = "/su-dashboard";
export const UPDATE_FILES_ROUTE = "/update-files";
export const PORTAL_CONTROL_ROUTE = "/portal-control";
export const HELP_AND_SUPPORT_ROUTE = "/help-and-support";
export const UPLOAD_PAGE_REDEFINED_ROUTE = "/upload-files";
export const DASHBOARD_ROUTE = "/dashboard";
